exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Task-container{padding:15px;line-height:2rem;word-wrap:break-word;transition:background-color .5s ease}.Task-container.incompleted:hover{background-color:#ffa07a}.Task-container.completed:hover{background-color:#e0ffff}.Task-container .Task-button,.Task-container .Task-label{display:inline-block}.Task-container .Task-label{width:170px;vertical-align:middle}.Task-container .Task-button{float:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/Task/Task.scss
// module id = 329
// module chunks = 0